import { useEffect, useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";

import { resolveImage } from "../../lib/media";
import { getPublicServerEndpoint } from "../../services/helper";
import Picture from "../Picture";
import SectionHeading from "../SectionHeading";

// type Review = {
//   _id: string;
//   storeId: string;
//   link?: string;
//   title?: string;
//   rating?: number;
//   image?: string;
//   sortOrder?: number;
//   createdAt: string;
//   updatedAt: string;
// };

// interface ReviewsProps {
//   storeId: string;
// }

const Reviews = ({ storeId }) => {
  const [reviews, setReviews] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const sortedReviews = reviews.sort((a, b) => a.sortOrder - b.sortOrder);

  const renderSkeletons = Array(6)
    .fill(0)
    .map((_, i) => <ReviewSkeleton key={i} />);

  const renderReviews = sortedReviews.map((review) => {
    const resolved = resolveImage(review.image, review.imageV2, "review");
    return (
      <div key={review._id}>
        {resolved.isV2 ? (
          <Picture
            resolved={resolved}
            alt={review.title || "Review Image"}
            imgClassName="h-[432px] min-w-[250px] rounded-2xl object-cover"
          />
        ) : (
          <LazyLoadImage
            className="h-[432px] min-w-[250px] rounded-2xl object-cover"
            src={resolved.src}
            alt={review.title || "Review Image"}
            effect="blur"
          />
        )}
      </div>
    );
  });

  useEffect(() => {
    const fetchReviews = async () => {
      setIsLoading(true);

      try {
        const response = await fetch(`${getPublicServerEndpoint()}/v2/review/store/${storeId}`);
        const data = await response.json();

        setReviews(data.data);
      } catch (error) {
        console.error("Error fetching reviews:", error);
        setReviews([]);
      } finally {
        setIsLoading(false);
      }
    };

    fetchReviews();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (sortedReviews.length === 0) return null;

  return (
    <div className="mt-[50px] pl-[20px] pr-[27px]">
      <SectionHeading label="Reviews" />

      <div className="hide-scrollbar mt-[30px] flex gap-x-5 overflow-x-auto">
        {isLoading ? renderSkeletons : renderReviews}
      </div>
    </div>
  );
};

const ReviewSkeleton = () => {
  return <div className="h-[432px] min-w-[250px] animate-pulse rounded-2xl bg-gray-200" />;
};

export default Reviews;
